<template>
    <section class="sectionBox" style="overflow: hidden">
        <!-- 左侧导航栏 -->
        <div class="left_box">
            <div class="searchBox">
                <el-input v-model="searchText" placeholder="输入关键词" suffix-icon="el-icon-search"></el-input>
            </div>
            <div class="listBox">
                <div class="menuBox">
                    <img src="../../assets/images/newIndex/addIcon.png" alt="" @click="showMenu(1)">
                    <span>日常工作</span>
                </div>
                <div class="menuItem" v-if="showMenui1">
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">机构管理</div>
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">党员档案</div>
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">组织发展</div>
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">一线报道</div>
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">党建宣传</div>
                </div>
            </div>
            <div class="listBox">
                <div class="menuBox">
                    <img src="../../assets/images/newIndex/addIcon.png" alt="" @click="showMenu(2)">
                    <span>网格动态</span>
                </div>
                <div class="menuItem" v-if="showMenui2">
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">我的工作</div>
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">事件受理</div>
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">纠纷处理</div>
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">会议直播</div>
                    <div class="itemIndex"><img src="../../assets/images/newIndex/addIcon.png" alt="">志愿服务</div>
                </div>
            </div>
        </div>
        <!-- 右侧内容区域 -->
        <div class="right_box">
            <!-- 面包屑导航 -->
            <div v-show="pageName!=''" class="mianbao">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/communityServices' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/partyBuilding' }">智慧党建</el-breadcrumb-item>
                    <el-breadcrumb-item>{{pageName}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <transition name="mains" enter-active-class="animated bounce">
                <router-view></router-view>
            </transition>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                searchText: '',
                showMenui1: true,
                showMenui2: true,
                isshow: false
            };
        },
        computed: {

            menu() {
                let arr = [];
                let menu = this.$store.state.menu;
                for (let item in menu) {
                    if (
                        menu[item].menuType == "1" &&
                        menu[item].path == "partyReported"
                    ) {
                        arr = menu[item].children;
                    }
                }
                return arr;
            },
            pageName() {
                let name = "";
                let menu = this.menu;
                // console.log(menu)
                for (let item in menu) {
                    if (menu[item].path == this.$route.name) {
                        name = menu[item].title;
                        break;
                    } else if (menu[item].children && menu[item].children.length > 0) {
                        for (let item1 in menu[item].children) {
                            if (menu[item].children[item1].path == this.$route.name) {
                                name = menu[item].children[item1].title;
                                break;
                            }
                        }
                    }
                }
                // console.log('title-'+name)
                return name;
            },
            handleOpen() {
            },
            handleClose() {
            },

        },
        mounted() {
        },
        methods: {
            toggle() {
                this.isshow = !this.isshow;
            },
            showMenu(type) {
                if(type=='1'){
                    this.showMenui1=!this.showMenui1
                }else if(type=='2'){
                    this.showMenui2=!this.showMenui2
                }

            }
        }
    };
</script>
<style lang="less" scoped>

    .left_box {
        background-color: #f4f4f4 !important;
    }

    .leftListBox {
        background-color: #fff;
    }

    .searchBox {
        margin-top: 10px;
        width: 100%;
        /*padding: 10px;*/
        box-sizing: border-box;
    }

    .listBox {
        background-color: #fff;
        margin-top: 10px;
    }

    .el-collapse-item {

    }

    .menuBox {
        box-sizing: border-box;
        border: 1px solid #f4f4f4;
        padding: 10px;
        font-size: 15px;
        background-color: #f8f9fa;
    }

    .menuBox img {
        vertical-align: middle;
        margin-right: 5px;
    }

    .menuItem {
        /*padding-left: 20px;*/
    }

    .menuItem .itemIndex {
        padding-left: 20px;
        border: 1px solid #f4f4f4;
        line-height: 40px;
    }

    .menuItem .itemIndex img {
        vertical-align: middle;
    }
</style>